export default __webpack_public_path__ + "static/media/Gilroy-ExtraBoldItalic.2df7a557.woff";